export default __webpack_public_path__ + "static/team5-7fb54c823560be802a23324553602569.jpg";